import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCurLocation, checkSession, GetMyLibrary, Logout } from './module';

const initialState = {
    curlocation: null,
    mySession: false,
    myLibs: {
        isMylibsLogin: false,
        RequestorNameFromLibs: null,
        RequestorEmailFromLibs: null,
        RequestorMobileFromLibs: null
    },
    status: "idle",
    ActionStatus: "",
    errorMessage: "",
    LogoutUrl: ""

};

export const checkSessionAsync = createAsyncThunk(
    'session/checkSession',
    async (index, ThunkAPI) => {
        const response = await checkSession();
        return response;
    }
);

export const CurLocationAsync = createAsyncThunk(
    'session/getCurLocation',
    async (index, ThunkAPI) => {
        const response = await getCurLocation();
        return response;
    }
);

export const GetMyLibraryAsync = createAsyncThunk(
    'session/GetMyLibrary',
    async (index, ThunkAPI) => {
        const response = await GetMyLibrary();
        return response;
    }
);
export const LogoutAsync = createAsyncThunk(
    'logout/Logout',
    async (index, ThunkAPI) => {
        const response = await Logout();
        return response;
    }
);
export const SessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(LogoutAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(LogoutAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(LogoutAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            // state.curlocation = action.payload;

            // if (action.payload && action.payload.Status !== 'OK') {
            state.LogoutUrl = action.payload.Data.LogoutUrl
            // }
        });

        builder.addCase(CurLocationAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(CurLocationAsync.rejected, (state) => {
            if (process.env.NODE_ENV !== "production") state.status = 'idle';
            state.status = 'rejected';
        });
        builder.addCase(CurLocationAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.curlocation = action.payload;

            if (action.payload && action.payload.Status !== 'OK') {
                //alert(action.payload.ErrorMessage)
            }
        });
        builder.addCase(checkSessionAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(checkSessionAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkSessionAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status === 'OK') {
                state.mySession = true;
            } else {
                state.mySession = false;
            }
        });
        builder.addCase(GetMyLibraryAsync.pending, (state) => {
            // state.status = 'loading';
        });
        builder.addCase(GetMyLibraryAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetMyLibraryAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status === 'OK' && action.payload.DisplayName) {
                state.myLibs = {
                    isMylibsLogin: true,
                    RequestorNameFromLibs: action.payload.DisplayName,
                    RequestorEmailFromLibs: action.payload.EmailAddress,
                    RequestorMobileFromLibs: action.payload.MobileNo
                }
            } else {
                state.myLibs = {
                    isMylibsLogin: false,
                    RequestorNameFromLibs: null,
                    RequestorEmailFromLibs: null,
                    RequestorMobileFromLibs: null
                }
            }
        });
    }
});

export const curlocation = (state) => state.Session.curlocation;
export const mySession = (state) => state.Session.mySession;
export const myLibs = (state) => state.Session.myLibs;
export const pagesState = (state) => state.Session;
export const logoutUrl = (state) => state.LogoutUrl;

export default SessionSlice.reducer;
